import { REASON_FOR_OPEN } from '../consts';
import { AccountOpeningReasonListItem } from './AccountOpeningReasonListItem';

interface AccountOpeningReasonListProps {
  reasonList: REASON_FOR_OPEN[];
  onClickItem: (reason: REASON_FOR_OPEN, title: string) => void;
}

export const AccountOpeningReasonList = ({
  reasonList,
  onClickItem,
}: AccountOpeningReasonListProps) => {
  return (
    <ul className='flex flex-col gap-4 mt-6'>
      {reasonList.map((reason) => (
        <AccountOpeningReasonListItem key={reason} reason={reason} onClickItem={onClickItem} />
      ))}
    </ul>
  );
};
